import { fetchWrapper } from '../../../services/fetchServices/fetchWrapper';

export function deleteSupplier(id: number) {
  return fetchWrapper({
    url: `/api/supplier/${id}`,
    fetchArg: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  });
}
